;"use strict";
window.overwatch = window.overwatch || {};
window.overwatch.BuyMediator = (function(overwatch) {

	/**
	 * [callbackMap description]
	 * @type {Object}
	 */
	var callbackMap = {};

	var Sku = null,
		Country = null,
		Platform = null,
		PrimaryRetailer = null,
		SecondaryRetailer = null;

	function init(config) {
		Sku = config.Sku;
		Country = config.Country;
		Platform = config.Platform;
		PrimaryRetailer = config.PrimaryRetailer;
		SecondaryRetailer = config.SecondaryRetailer;

		on(Sku.eventNameChange, function(sku) {
			//
			Platform.updateList(sku.id);

			//
			var currentPlatform = Platform.getCurrent();
			var country = Country.getCurrent();

			PrimaryRetailer.setCurrentRetailerByPlatformAndSkuIdAndCountryCode(currentPlatform, sku.id, country);
			SecondaryRetailer.setCurrentRetailersByCountryCodeAndSkuIdAndPlatform(country, sku.id, currentPlatform);
		});

		on(Country.eventNameChange, function(country) {
			//
			Sku.updateList(country);
		});

		on(Platform.eventNameChange, function(platform) {
			//
			var sku = Sku.getCurrent();
			var country = Country.getCurrent();

			PrimaryRetailer.setCurrentRetailerByPlatformAndSkuIdAndCountryCode(platform, sku.id, country);
			SecondaryRetailer.setCurrentRetailersByCountryCodeAndSkuIdAndPlatform(country, sku.id, platform);
		});

		on(PrimaryRetailer.eventNameChange, function(retailer) {
		});

		on(SecondaryRetailer.eventNameChange, function(retailers) {
		});
	}

	function on(event, cb, context) {
		context = context || this;
		var callbackList = (callbackMap[event] = callbackMap[event] || []);
		callbackList.push({ context: context, callback: cb });
	}

	function publish(event) {
		var callbackList = callbackMap[event] || [];
		var args = Array.prototype.slice.call(arguments, 1);
		for (var i = 0; i < callbackList.length; i++) {
			var callbackObj = callbackList[i];
			var context = callbackObj.context;
			var cb = callbackObj.callback;
			cb.apply(context, args);
		}
	}

	return {
		init: init,
		on: on,
		publish: publish
	};

}(window.overwatch));
